const t = {
  name: "LetterI",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1ZM11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4Z" fill="currentColor"/>
<path d="M9 10V20H7V22H17V20H15V8H6V10H9ZM13 20H11V10H13V20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as LetterI
};
